import React from 'react'
import * as Yup from 'yup'


const formView = (defaultValues) => [
	{
		name: 'shape_profile_name',
		label: 'Shape Profile Name',
		placeholder: 'Enter shape name',
		type: 'Input',
		className: 'col-span-6 row-span-1',
		defaultValue: defaultValues?.shape_profile_name || null,
		validation: Yup.string().required('Shape profile name is required'),
	},
	{
		label: 'Logo Parameters',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	{
		name: 'logo_parameters_size_width',
		label: 'Width (mm)',
		placeholder: 'Enter logo width',
		type: 'Number',
		className: 'col-span-3',
		defaultValue: Number(defaultValues?.logo_parameters_size_width) || null,
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'logo_parameters_size_height',
		label: 'Height (mm)',
		placeholder: 'Enter logo height',
		type: 'Number',
		className: 'col-span-3',
		defaultValue: Number(defaultValues?.logo_parameters_size_height) || null,
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'logo_parameters_offset_y',
		label: 'Offset Bottom (mm)',
		placeholder: 'Enter logo offset bottom',
		type: 'Number',
		className: 'col-span-3',
		defaultValue: Number(defaultValues?.logo_parameters_offset_y) || '0',
		min: 0,
		max: 215,
		validation: Yup.number().typeError('Required').min(0, 'Must be at least 0').max(215, 'Must be at most 215'),
		reset: false,
		clear: false,
	},
	{
		name: 'logo_parameters_offset_angle',
		label: 'Offset Angle (degrees)',
		placeholder: 'Enter logo offset angle',
		type: 'Number',
		min: -359,
		max: 359,
		className: 'col-span-3',
		defaultValue: defaultValues?.logo_parameters_offset_angle || '0',
		validation: Yup.number().typeError('Required').lessThan(360, "Must be less than 360").moreThan(-360, "Must be grater than -360"),
		reset: false,
		clear: false,
	},
	{
		name: 'logo_parameters_camera_job_id',
		label: 'Camera Job',
		placeholder: 'Select logo camera job',
		type: 'Select',
		staticApi: {
			url: '/camera-jobs',
			optionValue: (item) => ({
				value: item.id,
				label: item.name,
			}),
			
		},
		/*list: [
			{label: 'Takeya', value: '48672829-fa19-431e-bced-652169912571'},
			{label: 'Takeya Sport', value: '90ebc870-97df-4d1d-9281-4b07edbaa3b2'},
			{label: 'ThermoFlask', value: 'dc4f8324-3548-11ee-be56-0242ac120002'},
			{label: 'Yeti', value: '49421115-7fd9-4273-8476-be27aea50644'},
			{label: 'Stanley', value: 'c6419f85-0242-404b-89df-9cc79df53d57'},
			{label: 'Zoku', value: 'cf1cd21e-ec95-46b6-a99d-450f86818e7b'},
			{label: 'Owala', value: 'aca7bae6-13e3-4def-aca8-8ce2bfe9c0d1'},
			{label: 'hydroflask', value: 'db539898-ffde-49e9-818e-05832ff6a61c'},
			{label: 'RTIC', value: '66b7caea-53a3-47a5-99dc-ad5f39e612ac'},
			{label: 'Neatolabs', value: '1d684904-3b95-46a1-b8ff-d6a3b30ed5b6'},
		],*/
		className: 'col-span-6 row-span-1',
		defaultValue: defaultValues?.logo_parameters_camera_job_id || null,
		menuPortalTarget: 'false',
		validation: Yup.string().required('Camera is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'hiddenHeader8',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	
	{
		name: 'logo_parameters_led_brightness',
		label: 'LED Brightness',
		placeholder: 'Select Camera Led Brightness',
		type: 'NumberSlider',
		max: 512,
		min: 0,
		hint: 'Adjusts camera flash brightness (from 255-512 increases exposure while led is on max).',
		className: 'col-span-6 row-span-1',
		defaultValue: defaultValues?.logo_parameters_led_brightness === "0" ? 0 :  defaultValues?.logo_parameters_led_brightness || 255,
		
		reset: false,
		clear: false,
	},
	
	/*{
		name: 'logo_parameters_led_brightness',
		label: 'LED Brightness',
		placeholder: 'Select Camera Led Brightness',
		type: 'Select',
		list: [
			{label: 'Dark', value: 'dark'},
			{label: 'Bright', value: 'bright'},
		],
		className: 'col-span-6 row-span-1',
		defaultValue: defaultValues?.logo_parameters_led_brightness || 'bright',
		menuPortalTarget: 'false',
		validation: Yup.string().required('LED Brightness is Required'),
		reset: false,
		clear: false,
	},*/
	
	{
		name: 'hiddenHeader7',
		label: 'Gripper Plane',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	{
		name: 'gripper_plane_x',
		label: 'X Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_x || '0',
		validation: Yup.number().typeError('Required').lessThan(20).moreThan(-20),//Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'gripper_plane_y',
		label: 'Y Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_y
			? defaultValues?.gripper_plane_y
			: defaultValues?.stl?.y
				? 0 - parseFloat(defaultValues?.stl?.y / 2).toFixed(2)
				: null,
		validation: Yup.number().typeError('Required').moreThan(-300).max(0),
		reset: false,
		clear: false,
	},
	{
		name: 'gripper_plane_z',
		label: 'Z Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_z
			? defaultValues?.gripper_plane_z
			: defaultValues?.stl?.z
				? 0 - parseFloat(Number(defaultValues?.stl?.z) / 2).toFixed(2)
				: null,
		validation: Yup.number().typeError('Required').min(-150).max(0),
		reset: false,
		clear: false,
	},
	{
		name: 'hiddenHeader6',
		label: '',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'hidden',
	},
	{
		name: 'gripper_plane_x_angle',
		label: 'X Angle (degrees)',
		placeholder: 'Enter rotation',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_x_angle || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'gripper_plane_y_angle',
		label: 'Y Angle (degrees)',
		placeholder: 'Enter rotation',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_y_angle || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'gripper_plane_z_angle',
		label: 'Z Angle (degrees)',
		placeholder: 'Enter rotation',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.gripper_plane_z_angle || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	
	{
		name: 'hiddenHeader5',
		label: 'Center Of Gravity',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	{
		name: 'center_of_gravity_x',
		label: 'X Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.center_of_gravity_x || '0',
		validation: Yup.number().typeError('Required').lessThan(10).moreThan(-10),//Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'center_of_gravity_y',
		label: 'Y Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.center_of_gravity_y || '0',
		validation: Yup.number().typeError('Required').lessThan(10).moreThan(-10),
		reset: false,
		clear: false,
	},
	{
		name: 'center_of_gravity_z',
		label: 'Z Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		//defaultValue: defaultValues?.center_of_gravity_z || null,
		defaultValue: defaultValues?.center_of_gravity_z
			? defaultValues?.center_of_gravity_z
			: defaultValues?.glb
				? defaultValues?.glb
				: null,
		validation: Yup.number().typeError('Required').lessThan(300).min(0),
		reset: false,
		clear: false,
	},
	
	{
		name: 'hiddenHeader4',
		label: 'Base point',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	{
		name: 'base_point_x',
		label: 'X Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.base_point_x || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'base_point_y',
		label: 'Y Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.base_point_y || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	{
		name: 'base_point_z',
		label: 'Z Position (mm)',
		placeholder: 'Enter position',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.base_point_z || '0',
		validation: Yup.string().required('Required'),
		reset: false,
		clear: false,
	},
	
	{
		name: 'hiddenHeader3',
		label: 'Shape Parameters',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	{
		name: 'height',
		label: 'Height (mm)',
		placeholder: 'Enter height',
		type: 'Number',
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.height
			? defaultValues?.height
			: defaultValues?.stl?.y
				? parseFloat(defaultValues?.stl?.y).toFixed(2)
				: null,
		validation: Yup.number().typeError('Height is required').lessThan(300).moreThan(0),
		reset: false,
		clear: false,
	},
	{
		name: 'shape',
		label: 'Shape',
		placeholder: 'Select shape',
		type: 'Select',
		list: [
			{label: 'Undefined', value: 'undefined'},
			{label: 'Sphere', value: 'sphere'},
			{label: 'Cylinder', value: 'cylinder'},
			{label: 'Cone', value: 'cone'},
			{label: 'Revolve', value: 'revolve'},
		],
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.shape || 'revolve',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Shape is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'distance_unit_name',
		label: 'Distance Unit Name',
		placeholder: 'Select unit',
		type: 'Select',
		list: [
			{label: 'Millimeters', value: 'millimeters'},
			{label: 'Centimeters', value: 'centimeters'},
		],
		className: 'col-span-4 row-span-1 col-start-1',
		defaultValue: defaultValues?.distance_unit_name || 'millimeters',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Distance Unit is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'angle_unit_name',
		label: 'Angle Unit Name',
		placeholder: 'Select unit',
		type: 'Select',
		list: [
			{label: 'Degrees', value: 'degrees'},
			{label: 'Radians', value: 'radians'},
		],
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.angle_unit_name || 'degrees',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Angle unit is required'),
		reset: false,
		clear: false,
	},
	
	{
		name: 'mass',
		label: 'Mass (Kg)',
		placeholder: 'Enter mass',
		type: 'Number',
		className: 'col-span-3 row-span-1',
		defaultValue: defaultValues?.mass || null,
		menuPortalTarget: 'false',
		validation: Yup.number().typeError('Required').max(2, "must be less than 2Kg").moreThan(0, "must be greater than 0Kg"),
		reset: false,
		clear: false,
	},
	{
		name: 'mass_unit_name',
		label: 'Mass Unit ' + defaultValues?.mass_unit_name,
		placeholder: 'Select mass unit',
		type: 'Hidden',
		list: [
			{label: 'Kilograms', value: 'kilograms'},
			/* {label: 'Grams', value: 'grams'},*/
		],
		className: 'col-span-4 row-span-1',
		defaultValue: "kilograms",//defaultValues?.mass_unit_name || 'kilograms',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Mass Unit is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'hiddenHeader1',
		label: '',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-12 row-span-1 pt-[16px]',
	},
	
	{
		name: 'surface_marking_method',
		label: 'Surface Marking Method',
		placeholder: 'Select method',
		type: 'Select',
		list: [
			{label: 'Wrapping Length', value: 'wrapping_length'},
			{label: 'Wrapping Angle', value: 'wrapping_angle'},
			{label: 'Projection', value: 'projection'},
		],
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.surface_marking_method || 'wrapping_length',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Method is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'tool_id',
		label: 'Tool Id',
		placeholder: 'Select tool',
		type: 'Select',
		list: [{label: 'Default', value: 'default'}],
		className: 'col-span-4 row-span-1',
		defaultValue: defaultValues?.tool_id || 'default',
		menuPortalTarget: 'false',
		validation: Yup.string().required('Tool Id is required'),
		reset: false,
		clear: false,
	},
	{
		name: 'hiddenHeader2',
		label: '',
		type: 'Header',
		labelClassName: 'hidden',
		className: 'col-span-6 row-span-1 pt-[16px]',
	},
	{
		name: 'start_group',
		label: 'Advance',
		//description: 'Group is here',
		type: 'Group',
		child: ['tool_id', 'surface_marking_method', 'hiddenHeader1', 'angle_unit_name', 'distance_unit_name', 'shape',
			'height', 'hiddenHeader3', 'base_point_z', 'base_point_y', 'base_point_x', 'hiddenHeader4', 'center_of_gravity_z',
			'center_of_gravity_y', 'center_of_gravity_x', 'hiddenHeader5', 'gripper_plane_z_angle', 'gripper_plane_y_angle',
			'gripper_plane_x_angle', 'hiddenHeader6', 'gripper_plane_z', 'gripper_plane_y', 'gripper_plane_x', 'hiddenHeader7',
			'logo_parameters_led_brightness', 'hiddenHeader8'
		],
		toggle: true,
		layoutStyle: 'py-xl px-xl grid grid-cols-12 gap-md',
		className: 'col-span-12 row-span-1 pt-[16px]'
	}
]

export default formView
